/* global Sentry */
/* eslint-disable no-confusing-arrow */
import 'babel-polyfill';
import 'custom-polyfill';
import Vue from 'vue';
import Meta from 'vue-meta';
import { sync } from 'vuex-router-sync';
import VueGtm from 'vue-gtm';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueClipboard from 'vue-clipboard2';
import vimeoPlayer from '@/components/generics/vimeo-player/vimeo-player.vue';
import store from '@/store';
import router from '@/router';
import app from '@/components/app/app.vue';
import animatedNumber from '@/components/animated-number/animated-number.vue';
import marketStateTooltip from '@/components/market/market-state-tooltip/market-state-tooltip.vue';
import clickOutsideDirective from '@/directives/click-outside';
import outerLinkDirective from '@/directives/outer-link';
import priceDisplayDirective from '@/directives/price-display';
import largeNumberDirective from '@/directives/large-number';
import stickyDirective from '@/directives/sticky';
import assetCdnSrcDirective from '@/directives/asset-cdn-src';
import contractNameDirective from '@/directives/contract-name';
import brandName from '@/components/brand-name/brand-name.vue';
import getIndex2RedirectUrl from '@/utils/redirect';

Vue.config.productionTip = false;

sync(store, router);

Vue.use(Meta);
Vue.use(VueYouTubeEmbed);
Vue.use(VueClipboard);
Vue.directive('click-outside', clickOutsideDirective);
Vue.directive('outer-link', outerLinkDirective);
Vue.directive('price-display', priceDisplayDirective);
Vue.directive('large-number', largeNumberDirective);
Vue.directive('sticky', stickyDirective);
Vue.directive('asset-cdn-src', assetCdnSrcDirective);
Vue.directive('contract-name', contractNameDirective);

Vue.filter('base32', value => value.toString(32).toUpperCase());
Vue.filter('pluralize', value => (value.charAt(value.length - 1) === 's') ? value : `${value}s`);
Vue.filter('usernameDisplay', (value) => {
  const limit = 14;
  const username = value || '';
  if (username.length >= limit) {
    return `${username.substr(0, limit)}...`;
  }
  return username;
});
Vue.filter('usernameDisplayLong', (value) => {
  const limit = 20;
  const username = value || '';
  if (username.length >= limit) {
    return `${username.substr(0, limit)}...`;
  }
  return username;
});
Vue.filter('ordinal', (value) => {
  const symbols = ['th', 'st', 'nd', 'rd'];
  const v = value % 100;
  const suffix = (symbols[(v - 20) % 10] || symbols[v] || symbols[0]);
  return `${value}${suffix}`;
});

Vue.component('brand-name', brandName);
Vue.component('animated-number', animatedNumber);
Vue.component('market-state-tooltip', marketStateTooltip);
Vue.component('vimeo-player', vimeoPlayer);

Vue.use(VueGtm, {
  debug: process.env.NODE_ENV === 'development',
});

if (typeof Sentry !== 'undefined' && process.env.NODE_ENV !== 'development' && process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  });
}


const index2RedirectUrl = getIndex2RedirectUrl();
if (index2RedirectUrl) {
  window.location.replace(index2RedirectUrl);
} else {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    store,
    router,
    render: h => h(app),
  });
}



// WEBPACK FOOTER //
// ./src/main.js